import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PrimaryButtonMedium as Button } from '@xingternal/malt-button';
import Input from '@xingternal/malt-text-input';

import PageviewTracker from '../../../Components/PageviewTracker/PageviewTracker';
import StretchButtonGroup from './../../../Components/StretchButtonGroup/StretchButtonGroup';
import Spacer from './../../../Components/Spacer/Spacer';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';
import CustomTextButton from './../../../Components/CustomMalt/TextButton';

import messages from './messages';
import { NEW_EMAIL_STEP } from '../constants';

const ConfirmationStep = ({
  toStep,
  newEmail,
  isSubmitting,
  handleChange,
  errors: { confirmationCodeError },
}) => (
  <>
    <PageviewTracker pageName={'wbm/Welcome/login/recovery/account/confirm'} />

    <CustomH>
      <FormattedMessage {...messages.title} />
    </CustomH>

    <CustomP>
      <FormattedMessage
        {...messages.description}
        values={{ username: <b>{newEmail}</b> }}
      />
    </CustomP>

    <Input
      inputMode={'numeric'}
      pattern={'[0-9]*'}
      name={'confirmationCode'}
      size={'m'}
      type={'tel'}
      maxLength={6}
      message={confirmationCodeError}
      onChange={handleChange}
      required
      autoFocus
      readOnly={isSubmitting}
      disabled={isSubmitting}
    />

    <StretchButtonGroup>
      <Button loading={isSubmitting} type={'submit'}>
        <FormattedMessage {...messages.submitLabel} />
      </Button>

      <Spacer size={2} />

      <CustomTextButton isPetrol onClick={() => toStep(NEW_EMAIL_STEP)}>
        <FormattedMessage {...messages.backLinkText} />
      </CustomTextButton>
    </StretchButtonGroup>
  </>
);

export default ConfirmationStep;
